
import { defineComponent } from "vue";

export default defineComponent({
  name: "TicketRoute",
  props: {
    fromCity: { type: String, required: true },
    toCity: { type: String, required: true },
    fromAirport: { type: String, required: true },
    toAirport: { type: String, required: true },
  },
});
